import axios from "axios";
import { setUser } from "../reducers/userSlice";
// https://aoad-demo-backend-004.azurewebsites.net
// http://127.0.0.1:5000

//export const url = "https://aoad-backend.uaenorth.cloudapp.azure.com";

export const url = process.env.REACT_APP_API_URL;

// Create axios instance
const instance = axios.create({
  baseURL: url,
});

// Create another instance for refresh token requests to avoid infinite loops
const refreshInstance = axios.create({
  baseURL: url,
});

// Function to refresh token
const refreshToken = async () => {
  try {
    const user = localStorage.getItem("user");
    const res = await refreshInstance.post(
      "/user/refresh",
      {},
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(user).refreshToken}`,
        },
      }
    );
    const newUser = {
      id: res.data.id,
      username: res.data.username,
      first_name: res.data.first_name,
      middle_name: res.data.middle_name,
      last_name: res.data.last_name,
      email: res.data.email,
      organization: res.data.organization,
      position: res.data.position,
      fields: res.data.fields,
      country: res.data.country,
      jwt: res.data.access_token,
      refreshToken: res.data.refresh_token,
      role: res.data.access,
    };
    localStorage.removeItem("user");
    localStorage.setItem("user", JSON.stringify(newUser));
    return res.data.access_token;
  } catch (error) {
    localStorage.removeItem("user");
    setUser("");
    throw error;
  }
};

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    try {
      const user = localStorage.getItem("user");
      const jwt = JSON.parse(user).jwt;
      config.headers.set("Authorization", `Bearer ${jwt}`);
    } catch {}
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
// Modify the response interceptor
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If error is 401 and we haven't tried to refresh the token yet
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const newToken = await refreshToken();
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return instance(originalRequest);
      } catch (refreshError) {
        // If refresh token fails, logout user
        localStorage.removeItem("user");
        setUser("");
        return Promise.reject(refreshError);
      }
    }
    if (
      error.response.status === 403 &&
      error.response.data.message === "token is invalid"
    ) {
      originalRequest._retry = true;
      try {
        const newToken = await refreshToken();
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return instance(originalRequest);
      } catch (refreshError) {
        // If refresh token fails, logout user
        localStorage.removeItem("user");
        setUser("");
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
